export const waybillTableHeader = 'waybill';
export const pickUpPointTableHeader = 'pickup point';
export const phoneNumberErr = 'Invalid phone number';
